import { default as GlobalAudit } from "./GlobalAudit";
import React from "react";

function AuditCard({ data }: { data?: any }) {
  return (
    <>
      <GlobalAudit log={data} />
    </>
  );
}

export default AuditCard;
